import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { CustomErrorValidatorParams } from './custom-error-validator-params';

export function customErrorValidator(params: CustomErrorValidatorParams): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let result = params.validator(control);

    if (result) {
      const firstError = Object.keys(result)[0];

      result = { customError: params.errors[firstError] };
    }

    return result;
  };
}
